// Minimal SW registration: Workbox-generated SW handles all caching; this file
// just hooks it into the page lifecycle and dispatches an 'sw-update-available'
// CustomEvent on window so SwUpdateToast can offer a one-click reload.

const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
  window.location.hostname === "[::1]" ||
  window.location.hostname.match(/^127(?:\.(?:\d+)){3}$/)
);

export function register() {
  if (!("serviceWorker" in navigator)) return;

  const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

  window.addEventListener("load", () => {
    if (isLocalhost) {
      // CRA dev server doesn't emit the SW; only register if it's actually served.
      fetch(swUrl, { headers: { "Service-Worker": "script" } })
        .then((res) => {
          const ct = res.headers.get("content-type") || "";
          if (res.status === 404 || !ct.includes("javascript")) {
            navigator.serviceWorker.ready.then((reg) => reg.unregister());
          } else {
            registerValid(swUrl);
          }
        })
        .catch(() => { /* offline at register time — fine */ });
    } else {
      registerValid(swUrl);
    }
  });
}

function registerValid(swUrl) {
  navigator.serviceWorker.register(swUrl)
    .then((registration) => {
      registration.onupdatefound = () => {
        const installing = registration.installing;
        if (!installing) return;
        installing.onstatechange = () => {
          if (installing.state === "installed" && navigator.serviceWorker.controller) {
            window.dispatchEvent(new CustomEvent("sw-update-available", {
              detail: { waiting: registration.waiting || installing },
            }));
          }
        };
      };
    })
    .catch((err) => console.error("Service worker registration failed:", err));
}

// Reload once the new SW takes control of the page. GenerateSW has
// skipWaiting + clientsClaim on, so the waiting/installing SW may have
// already activated by the time we get here — controllerchange is the
// canonical signal that a new SW is in charge. The 1500 ms fallback covers
// the case where the SW was already controlling and no event will fire.
export function applyUpdate(waiting) {
  let reloaded = false;
  const reload = () => {
    if (reloaded) return;
    reloaded = true;
    window.location.reload();
  };

  navigator.serviceWorker?.addEventListener("controllerchange", reload, { once: true });
  if (waiting && waiting.state === "installed") {
    try { waiting.postMessage({ type: "SKIP_WAITING" }); } catch { /* ignore */ }
  }
  setTimeout(reload, 1500);
}
